import { render } from "./EventSingle.vue?vue&type=template&id=1a623418&scoped=true"
import script from "./EventSingle.vue?vue&type=script&lang=js"
export * from "./EventSingle.vue?vue&type=script&lang=js"

import "./EventSingle.vue?vue&type=style&index=0&id=1a623418&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a623418"]])

export default __exports__